import { GenericHeader } from "../../Components/GenericHeader/GenericHeader";
import { Footer } from "../../Components/Footer/Footer";
import React from "react";
import { termsAndConditionsCSS } from "./TermsAndConditions.css";

export default function TermsAndConditions() {
  return (
    <div css={termsAndConditionsCSS()}>
      <GenericHeader />

      <div className="ContainerNoticePrivacy">
        <h1>Terminos y Condiciones</h1>

        
      </div>

      <Footer />
    </div>
  );
}
